/**
 * 权限管理工具类
 */

// 存储权限到 localStorage
export const saveUserFeatures = (features) => {
  if (!features) return;
  
  const featuresArray = Array.from(features);
  localStorage.setItem('user_features', JSON.stringify(featuresArray));
  console.log('✅ 保存用户权限:', featuresArray);
};

// 从 localStorage 获取权限
export const getUserFeatures = () => {
  const featuresStr = localStorage.getItem('user_features');
  if (!featuresStr) return [];
  
  try {
    return JSON.parse(featuresStr);
  } catch (e) {
    console.error('解析用户权限失败:', e);
    return [];
  }
};

// 清除权限
export const clearUserFeatures = () => {
  localStorage.removeItem('user_features');
};

// 检查是否有指定权限
export const hasPermission = (featureCode) => {
  const features = getUserFeatures();
  
  // 管理员拥有所有权限
  if (features.includes('*:all')) {
    return true;
  }
  
  return features.includes(featureCode);
};

// 检查是否有任意一个权限
export const hasAnyPermission = (featureCodes) => {
  return featureCodes.some(code => hasPermission(code));
};

// 检查是否有所有权限
export const hasAllPermissions = (featureCodes) => {
  return featureCodes.every(code => hasPermission(code));
};
